import React from "react";

import { ILeanProductTileWithBrand } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { MarketplaceProduct } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/MarketplaceProduct";
import { generateProductLinkPropsForLoggedOutRetailer } from "@faire/retailer/lib/generateProductLinkPropsForLoggedOutRetailer";
import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { ProductPagePaths } from "@faire/retailer/paths/ProductPage";

import { ProductLinkProps } from "../../MarketplaceItems/ProductTile";

interface IProps {
  className?: string;
  role?: string;
  value: ILeanProductTileWithBrand | undefined;
}

export const ProductTile: React.FC<IProps> = ({ value, role, className }) => {
  const generateProductLinkProps = (): ProductLinkProps | undefined => {
    if (!value?.product?.token) {
      return undefined;
    }

    const productPageLink = ProductPagePaths.index(value.product.token);

    if (!isLoggedInRetailer()) {
      return generateProductLinkPropsForLoggedOutRetailer({
        productToken: value.product.token,
        brandToken: value.product.brand_token,
      });
    }

    return { productUrl: productPageLink };
  };

  return (
    <MarketplaceProduct
      className={className}
      productTile={value}
      brand={value?.brand}
      role={role}
      generateProductLinkProps={generateProductLinkProps}
    />
  );
};
